import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Typography,
  Tab,
  Stack,
  Button,
  Card,
  CardContent,
  Grid,
  Chip,
  IconButton,
  Avatar,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider
} from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { PageTitle } from '../../common/PageTitle';
import { useNavigate } from 'react-router-dom';
import Axios from 'axios';
import { base_url } from '../../backendurl/url';
import { Config } from '../../../utils/commonFuctions/Token';
import { RefreshToken } from '../../../utils/commonFuctions/RefreshToken';
import { Notification } from '../../common/Notification';
import AddIcon from '@mui/icons-material/Add';
import SportsFootballIcon from '@mui/icons-material/SportsFootball';
import SportsBasketballIcon from '@mui/icons-material/SportsBasketball';
import SportsHockeyIcon from '@mui/icons-material/SportsHockey';
import SportsBaseballIcon from '@mui/icons-material/SportsBaseball';
import GamesModal from './GamesModal';
import LeaguesModal from './LeaguesModal';
import { TransButton } from '../../common/TransButton';
import { ConnectingAirportsOutlined } from '@mui/icons-material';
import { hasWritePermission } from '../../common/PermissionUtility';

function GameLeagues() {
  const navigate = useNavigate();
  const [value, setValue] = useState('preferred-games');
  const [loading, setLoading] = useState(false);
  const [gamesData, setGamesData] = useState([]);
  const [leaguesData, setLeaguesData] = useState([]);
  const [allLeaguesData, setAllLeaguesData] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [notification, setNotification] = useState(false);
  const canWriteUsers = hasWritePermission('game');
  const canWriteUsersLeagues = hasWritePermission('preferredleague');

  // Modal states
  const [gamesModalOpen, setGamesModalOpen] = useState(false);
  const [leaguesModalOpen, setLeaguesModalOpen] = useState(false);

  // Selected game state for leagues filtering
  const [selectedGame, setSelectedGame] = useState('Football');

  // Sample data - replace with actual API calls
  const sampleGames = [
    { id: 1, name: 'Football', icon: 'football', color: '#3C50E0' },
    { id: 2, name: 'Cricket', icon: 'cricket', color: '#10B981' },
    { id: 3, name: 'Tennis', icon: 'tennis', color: '#F59E0B' },
    { id: 4, name: 'Hockey', icon: 'hockey', color: '#EF4444' },
    { id: 5, name: 'NBA', icon: 'basketball', color: '#8B5CF6' },
    { id: 6, name: 'Base ball', icon: 'baseball', color: '#06B6D4' }
  ];

  const samplePreferredLeagues = [
    {
      id: 1,
      name: 'Premier League',
      logo: '/api/placeholder/40/40',
      game: 'Football',
      isPreferred: true,
      shortName: 'EPL'
    },
    {
      id: 2,
      name: 'Champions League',
      logo: '/api/placeholder/40/40',
      game: 'Football',
      isPreferred: true,
      shortName: 'UCL'
    },
    {
      id: 3,
      name: 'UEFA Europa League',
      logo: '/api/placeholder/40/40',
      game: 'Football',
      isPreferred: true,
      shortName: 'UEL'
    },
    {
      id: 4,
      name: 'LaLiga',
      logo: '/api/placeholder/40/40',
      game: 'Football',
      isPreferred: true,
      shortName: 'LaLiga'
    },
    {
      id: 5,
      name: 'Serie A',
      logo: '/api/placeholder/40/40',
      game: 'Football',
      isPreferred: true,
      shortName: 'Serie A'
    },
    {
      id: 6,
      name: 'Bundesliga',
      logo: '/api/placeholder/40/40',
      game: 'Football',
      isPreferred: true,
      shortName: 'Bundesliga'
    },
    {
      id: 7,
      name: 'IPL',
      logo: '/api/placeholder/40/40',
      game: 'Cricket',
      isPreferred: true,
      shortName: 'IPL'
    },
    {
      id: 8,
      name: 'Big Bash League',
      logo: '/api/placeholder/40/40',
      game: 'Cricket',
      isPreferred: true,
      shortName: 'BBL'
    },
    {
      id: 9,
      name: 'NBA',
      logo: '/api/placeholder/40/40',
      game: 'NBA',
      isPreferred: true,
      shortName: 'NBA'
    },
    {
      id: 10,
      name: 'NHL',
      logo: '/api/placeholder/40/40',
      game: 'Hockey',
      isPreferred: true,
      shortName: 'NHL'
    }
  ];

  const sampleAllLeagues = [
    {
      id: 1,
      name: 'Premier League',
      logo: '/api/placeholder/40/40',
      game: 'Football',
      isPreferred: true
    },
    {
      id: 2,
      name: 'EPL',
      logo: '/api/placeholder/40/40',
      game: 'Football',
      isPreferred: true
    },
    {
      id: 3,
      name: 'UEFA',
      logo: '/api/placeholder/40/40',
      game: 'Football',
      isPreferred: true
    },
    {
      id: 4,
      name: 'LaLiga',
      logo: '/api/placeholder/40/40',
      game: 'Football',
      isPreferred: true
    },
    {
      id: 5,
      name: 'Serie A',
      logo: '/api/placeholder/40/40',
      game: 'Football',
      isPreferred: false
    },
    {
      id: 6,
      name: 'Bundesliga',
      logo: '/api/placeholder/40/40',
      game: 'Football',
      isPreferred: false
    },
    {
      id: 7,
      name: 'NBA',
      logo: '/api/placeholder/40/40',
      game: 'Basketball',
      isPreferred: false
    },
    {
      id: 8,
      name: 'IPL',
      logo: '/api/placeholder/40/40',
      game: 'Cricket',
      isPreferred: false
    }
  ];

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 'preferred-leagues' && gamesData.length > 0) {
      setSelectedGame(gamesData[0].id);
    }
  };
  //console.log(gamesData, "GamesDataValues")
  const getGamesData = useCallback(async () => {
    try {
      if (!loading) {
        setLoading(true);
        // Replace with actual API call
        const response = await Axios.get(`${base_url}/api/pot/games`, Config);
        console.log(response, "response123")
        if (response?.status === 200) {
          setGamesData(response?.data?.data);
        }
        //  setGamesData(sampleGames);
        setLoading(false);
      }
    } catch (error) {
      RefreshToken(error, setErrorMessage, setNotification);
      setLoading(false);
    }
  }, []);

  const handleRefreshGames = useCallback(() => {
    console.log('Refreshing games data...');
    getGamesData();
  }, [getGamesData]);

  const getPreferredLeaguesData = useCallback(async () => {
    try {
      if (!loading) {
        setLoading(true);
        // Replace with actual API call
        const response = await Axios.get(`${base_url}/api/pot/preferredleagues`, Config);
        //console.log(response, "response222")
        if (response?.status === 200) {
          setLeaguesData(response?.data);
        }
        //setLeaguesData(samplePreferredLeagues);
        setLoading(false);
      }
    } catch (error) {
      RefreshToken(error, setErrorMessage, setNotification);
      setLoading(false);
    }
  }, []);

  //   const handleRefreshLeagues = useCallback(() => {
  //   console.log('Refreshing games data...');
  //   getPreferredLeaguesData();
  // }, [getPreferredLeaguesData]);
  const handleRefreshLeagues = useCallback(async () => {
    console.log('Refreshing leagues data...');
    try {
      await getPreferredLeaguesData(); // Make sure to await this
      console.log('Leagues refresh completed');
    } catch (error) {
      console.error('Error refreshing leagues:', error);
    }
  }, [getPreferredLeaguesData]);

  const getAllLeaguesData = useCallback(async () => {
    try {
      if (!loading) {
        setLoading(true);
        // Replace with actual API call
        // const response = await Axios.get(`${base_url}/api/leagues/all`, Config);
        // if (response?.status === 200) {
        //   setAllLeaguesData(response?.data?.data);
        // }
        setAllLeaguesData(sampleAllLeagues);
        setLoading(false);
      }
    } catch (error) {
      RefreshToken(error, setErrorMessage, setNotification);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (value === 'preferred-games') {
      getGamesData();
    } else if (value === 'preferred-leagues') {
      getGamesData();
      getPreferredLeaguesData();
    } else if (value === 'all-leagues') {
      getAllLeaguesData();
    }
  }, [value, getGamesData, getPreferredLeaguesData, getAllLeaguesData]);

  const getGameIcon = (iconType) => {
    //console.log(iconType, "iconType");
    if (typeof iconType === 'string' && iconType.startsWith('http')) {
      return (
        <img
          src={iconType}
          alt="Game icon"
          style={{
            width: 40,
            height: 40,
            objectFit: 'contain'
          }}
        />
      );
    }

    switch (iconType) {
      case 'football':
        return <SportsFootballIcon sx={{ fontSize: 40, color: '#fff' }} />;
      case 'basketball':
        return <SportsBasketballIcon sx={{ fontSize: 40, color: '#fff' }} />;
      case 'hockey':
        return <SportsHockeyIcon sx={{ fontSize: 40, color: '#fff' }} />;
      case 'baseball':
        return <SportsBaseballIcon sx={{ fontSize: 40, color: '#fff' }} />;
      default:
        return <SportsFootballIcon sx={{ fontSize: 40, color: '#fff' }} />;
    }
  };

  const handleAddNew = (tabType) => {
    if (tabType === 'games') {
      setGamesModalOpen(true);
    } else if (tabType === 'preferred-leagues') {
      getPreferredLeaguesData();
      setLeaguesModalOpen(true);
      // Or navigate to leagues form
      // navigate('/configurations/leagues/preferred/add');
    } else if (tabType === 'all-leagues') {
      // Handle all leagues modal or navigation
      console.log('Opening all leagues popup');
    }
  };

  const handleGamesModalSave = (selectedGames) => {
    //console.log('Selected games:', selectedGames);
    // Update the gamesData state with selected games
    setGamesData(selectedGames);
    // await Axios.post(`${base_url}/api/games/update-preferred`, { games: selectedGames }, Config);
  };

  const handleLeaguesModalSave = (selectedLeagues) => {
    // console.log('Selected leagues:', selectedLeagues);
    setLeaguesData(selectedLeagues);
    // await Axios.post(`${base_url}/api/leagues/update-preferred`, { leagues: selectedLeagues }, Config);
  };

  const getTabTitle = () => {
    switch (value) {
      case 'preferred-games':
        return 'Preferred Sports';
      case 'preferred-leagues':
        return 'Preferred League';
      case 'all-leagues':
        return 'All Leagues';
      default:
        return '';
    }
  };

  const getTabDescription = () => {
    switch (value) {
      case 'preferred-games':
        return 'The below sports will be displayed for the user while onboarding.';
      case 'preferred-leagues':
        return 'The below league will be displayed for the user while onboarding.';
      case 'all-leagues':
        return 'Complete list of all available leagues in the system.';
      default:
        return '';
    }
  };

  const getButtonAction = () => {
    switch (value) {
      case 'preferred-games':
        return () => handleAddNew('games');
      case 'preferred-leagues':
        return () => handleAddNew('preferred-leagues');
      case 'all-leagues':
        return () => handleAddNew('all-leagues');
      default:
        return () => { };
    }
  };

  // Filter leagues based on selected game
  const getFilteredLeagues = () => {
    // console.log(leaguesData, "leaguesData");
    // console.log(selectedGame, "selectedGame")
    return leaguesData.filter(league => league.game === selectedGame);
  };

  const handleGameSelect = (gameName) => {
    setSelectedGame(gameName);
  };

  return (
    <Box sx={{ width: '100%', typography: 'body1', backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      <Stack direction={'row'} sx={{ justifyContent: 'space-between', px: 6, pt: 3 }} alignItems="center">
        <PageTitle pageTitle={'Sports & League'} />
      </Stack>

      <Typography
        variant="body2"
        sx={{
          px: 6,
          pt: 1,
          color: '#6B7280',
          fontSize: '14px'
        }}
      >
        Configure which of below sports & league can be listed below.
      </Typography>

      <TabContext value={value} sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', backgroundColor: '#fff' }}>
          <TabList
            sx={{ px: 6, pt: 3 }}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            aria-label="games leagues tabs"
          >
            <Tab
              label="Preferred Sports"
              value="preferred-games"
              sx={{
                color: value === 'preferred-games' ? '#3C50E0 !important' : '#6B7280',
                cursor: 'pointer',
                textTransform: 'none',
                fontWeight: value === 'preferred-games' ? 600 : 400,
                fontSize: '16px'
              }}
            />
            <Tab
              label="Preferred League"
              value="preferred-leagues"
              sx={{
                color: value === 'preferred-leagues' ? '#3C50E0 !important' : '#6B7280',
                cursor: 'pointer',
                textTransform: 'none',
                fontWeight: value === 'preferred-leagues' ? 600 : 400,
                fontSize: '16px'
              }}
            />
          </TabList>
        </Box>

        <TabPanel value="preferred-games" sx={{ width: '100%', px: 6, py: 4 }}>
          {/* Section Header with Add/Edit Button */}
          <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <Box>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  fontSize: '18px',
                  color: '#1F2937',
                  mb: 1
                }}
              >
                {getTabTitle()}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: '#6B7280',
                  fontSize: '14px'
                }}
              >
                {getTabDescription()}
              </Typography>
            </Box>
            {/* <Button 
              sx={{ 
                backgroundColor: '#3C50E0', 
                color: '#EFF4FB',  
                '&:hover': { backgroundColor: '#3C50E0', color: '#EFF4FB' },
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 600,
                minWidth: '120px'
              }} 
              onClick={getButtonAction()}
              startIcon={<AddIcon />}
            >
              Add / Edit
            </Button> */}
              {canWriteUsers && (
            <TransButton
              title="Add / Edit +"
              onClick={getButtonAction()}
            />
              )}
          </Box>

          <Grid container spacing={3}>
            {gamesData.map((game) => (
              <Grid item xs={12} sm={6} md={4} lg={2} key={game.id}>
                <Card
                  sx={{
                    borderRadius: '12px',
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                    border: '1px solid #E5E7EB',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease-in-out',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    '&:hover': {
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                      transform: 'translateY(-2px)'
                    }
                  }}
                >
                  <CardContent sx={{ p: 3, textAlign: 'center' }}>
                    <Box
                      sx={{
                        width: 80,
                        height: 80,
                        borderRadius: '16px',
                        backgroundColor: game.color,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mx: 'auto',
                        mb: 2
                      }}
                    >
                      {getGameIcon(game.logo)}
                    </Box>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        fontSize: '16px',
                        color: '#1F2937'
                      }}
                    >
                      {game.game_name}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </TabPanel>

        <TabPanel value="preferred-leagues" sx={{ width: '100%', px: 6, py: 4 }}>
          {/* Section Header with Add/Edit Button */}
          <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <Box>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  fontSize: '18px',
                  color: '#1F2937',
                  mb: 1
                }}
              >
                {getTabTitle()}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: '#6B7280',
                  fontSize: '14px'
                }}
              >
                {getTabDescription()}
              </Typography>
            </Box>
            {/* <Button 
              sx={{ 
                backgroundColor: '#3C50E0', 
                color: '#EFF4FB',  
                '&:hover': { backgroundColor: '#3C50E0', color: '#EFF4FB' },
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 600,
                minWidth: '120px'
              }} 
              onClick={getButtonAction()}
              startIcon={<AddIcon />}
            >
              Add / Edit
            </Button> */}
              {canWriteUsers && (
            <TransButton
              title="Add / Edit +"
              onClick={getButtonAction()}
            />
              )}
          </Box>

          {/* Two Column Layout */}
          <Grid container spacing={3}>
            {/* Left Column - Games List */}
            <Grid item xs={12} md={3}>
              <Card
                sx={{
                  borderRadius: '12px',
                  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                  border: '1px solid #E5E7EB',
                  height: 'fit-content',
                  backgroundColor: "#F6F6F6"
                }}
              >
                <CardContent sx={{ p: 2 }}>
                  <List sx={{ p: 0 }}>
                    {gamesData.map((game, index) => (
                      <React.Fragment key={game.id}>
                        <ListItem sx={{ p: 0 }}>
                          <ListItemButton
                            onClick={() => handleGameSelect(game.id)}
                            sx={{
                              py: 0.5,
                              px: 1,
                              backgroundColor: selectedGame === game.id ? '#3C50E0' : 'transparent',
                              color: selectedGame === game.id ? '#fff' : '#1F2937',
                              '&:hover': {
                                //backgroundColor: selectedGame === game.id ? '#3C50E0' : '#F3F4F6'
                                backgroundColor: '#3C50E0'
                              },
                              borderRadius: selectedGame === game.id ? '3px' : '0px',
                              //mx: selectedGame === game.name ? 1 : 0,
                              mx: selectedGame === game.id ? 0 : 0,
                              my: selectedGame === game.id ? 0.5 : 0
                            }}
                          >
                            <ListItemText
                              primary={game.game_name}
                              primaryTypographyProps={{
                                fontWeight: selectedGame === game.id ? 600 : 400,
                                fontSize: '14px'
                              }}
                            />
                          </ListItemButton>
                        </ListItem>
                        {index < gamesData.length - 1 && selectedGame !== game.id && selectedGame !== gamesData[index + 1]?.game_name && (
                          <Divider />
                        )}
                      </React.Fragment>
                    ))}
                  </List>
                </CardContent>
              </Card>
            </Grid>

            {/* Right Column - Leagues Grid */}
            <Grid item xs={12} md={9}>
              <Grid container spacing={2}>
                {getFilteredLeagues().map((league) => (
                  <Grid item xs={12} sm={6} md={3} lg={3} key={league.id}>
                    <Card
                      sx={{
                        borderRadius: '12px',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                        border: '1px solid #E5E7EB',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease-in-out',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        '&:hover': {
                          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                          transform: 'translateY(-2px)'
                        }
                      }}
                    >
                      <CardContent sx={{ p: 3, textAlign: 'center' }}>
                        <Avatar
                          src={league.logo_url}
                          sx={{
                            width: 48,
                            height: 48,
                            mx: 'auto',
                            mb: 2,
                            backgroundColor: '#F3F4F6'
                          }}
                        >
                          {league.shortName ? league.shortName.charAt(0) : league.name.charAt(0)}
                        </Avatar>
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: 500,
                            fontSize: '14px',
                            color: '#1F2937',
                            textAlign: 'center'
                          }}
                        >
                          {league.shortName || league.name}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>

              {getFilteredLeagues().length === 0 && (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '200px',
                    border: '2px dashed #E5E7EB',
                    borderRadius: '12px',
                    backgroundColor: '#F9FAFB'
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#6B7280',
                      fontSize: '14px'
                    }}
                  >
                    No leagues found
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        </TabPanel>
      </TabContext>

      {/* Games Modal */}
      <GamesModal
        open={gamesModalOpen}
        onClose={() => setGamesModalOpen(false)}
        onSave={handleGamesModalSave}
        data={gamesData} // Pass current games data
        onRefreshGames={handleRefreshGames}
      />

      {/* <LeaguesModal
  open={leaguesModalOpen}
  onClose={() => setLeaguesModalOpen(false)}
  onSave={handleLeaguesModalSave}
/> */}

      <LeaguesModal
        open={leaguesModalOpen}
        onClose={() => setLeaguesModalOpen(false)}
        onSave={handleLeaguesModalSave}
        currentLeagues={leaguesData}
        currentGames={gamesData}
        onRefreshLeagues={handleRefreshLeagues}
      />

      <Notification
        message={errorMessage}
        setopen={setNotification}
        type={'error'}
        show={notification}
      />
    </Box>
  );
}

export default GameLeagues;